import React, { useMemo } from 'react';
import { GridEventListener } from '@mui/x-data-grid-pro';
import EDBox from '../../../../../../../../../BaseComponents/EDBox/EDBox';
import { IAssociationListConfig } from '../../../../../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import CollectionList from '../../../../../../../_Common/Components/BusinessCollectionComponents/CollectionList/CollectionList';
import { ISelectedKundRow } from '../../BokforderCreateDialog';
import { makeTillgodourval } from '../../Utils/BokforderCreateDialogUtils';

interface IProps {
  valdTillgodoKund: ISelectedKundRow | null;
  setValdTillgodoKund: React.Dispatch<
    React.SetStateAction<ISelectedKundRow | null>
  >;
}

const kundConfig: IAssociationListConfig = {
  customDefaultColumns: [
    { attributeDef: 'KUNDNR_KONTONR', caption: 'Kundnr' },
    { attributeDef: 'Namn', caption: 'Namn' },
    { attributeDef: 'Tillgodohavande', caption: 'Tillgodohavande, kr' },
  ],
  defaultVisningstyp: 'tabell',
  inCard: true,
  autoHeight: false,
  customBusinessConfig: {
    dataDependencies: ['OrgPers._typ', 'KundKategori.id'],
  },
};

const UtanordningTillgodoDialog: React.FC<IProps> = props => {
  const { setValdTillgodoKund } = props;

  const tillgodoSelection = useMemo(() => makeTillgodourval(), []);

  const onRowClick: GridEventListener<'rowClick'> = (
    params,
    event,
    details
  ) => {
    if (
      props.valdTillgodoKund?.id === params.id.toString() &&
      event.ctrlKey === true
    ) {
      setValdTillgodoKund(null);
    } else {
      const rowData = params.row?.collectionData;
      if (rowData) {
        setValdTillgodoKund({
          KUNDNR_KONTONR: rowData?.KUNDNR_KONTONR,
          id: rowData?.id,
          Namn: rowData?.Namn,
          Tillgodohavande: rowData?.Tillgodohavande,
          _Associations: {
            OrgPers: {
              _typ: rowData._Associations.OrgPers._typ,
            },
            KundKategori: {
              id: rowData._Associations.KundKategori.id,
            },
          },
        });
      }
    }
  };

  return (
    <EDBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 28px)',
      }}
    >
      <CollectionList
        collectionName="KRKund"
        config={kundConfig}
        onRowClick={onRowClick}
        selectionGrid
        selectedId={props.valdTillgodoKund?.id}
        urval={tillgodoSelection}
        filterAttributes={[
          { attribute: 'KUNDNR_KONTONR', label: 'Kundnr' },
          { attribute: 'Namn', label: 'Namn' },
        ]}
      />
    </EDBox>
  );
};

export default UtanordningTillgodoDialog;
